/**
 * Sticky Header Module
 * Manages header visibility with iOS optimizations
 */

var stickyHeader = {
    lastScrollTop: 0,
    scrollThreshold: 3,
    headerHeight: 0,
    isSticky: false,
    scrollTimeout: null,
    isIOSDevice: /iPad|iPhone|iPod/.test(navigator.userAgent),
    iosScrollUpLock: false,
    iosLockTimeout: null,

    init: function () {
        this.cacheElements();
        this.setupEventListeners();
        this.setInitialState();
    },

    cacheElements: function () {
        this.$header = $('.site-header');
        this.$headerBanner = $('.header-banner');
        this.$nav = this.$header.find('nav');
        this.$body = $('body');
        this.$window = $(window);
    },

    setupEventListeners: function () {
        var self = this;

        this.$window.on('scroll.stickyHeader', function () {
            if (self.scrollTimeout) {
                cancelAnimationFrame(self.scrollTimeout);
            }
            self.scrollTimeout = requestAnimationFrame(function () {
                self.handleScroll();
            });
        });

        this.$window.on('resize.stickyHeader', function () {
            self.calculateHeaderHeight();
        });

        $(document).on('wheel.stickyHeader', '.refinement-bar', function (e) {
            if (self.$window.width() < 768) {
                return;
            }
            var scrollingUp = e.originalEvent.deltaY < 0;
            var pageIsScrolled = self.$window.scrollTop() > 0;
            var headerIsVisible = !self.$header.hasClass('header-hidden');
            if (scrollingUp && pageIsScrolled && headerIsVisible) {
                self.hideHeader();
            }
        });

        $(document).ready(function () {
            self.calculateHeaderHeight();
        })
    },

    calculateHeaderHeight: function () {
        if (this.$header.length) {
            this.headerHeight = this.$header.outerHeight();
            this.$body.css('--header-height', this.headerHeight + 'px');
        }
    },

    setInitialState: function () {
        this.$header.removeClass('header-hidden header-sticky');
        this.$body.removeClass('header-is-sticky');
        this.isSticky = false;
        this.iosScrollUpLock = false;
        if (this.iosLockTimeout) {
            clearTimeout(this.iosLockTimeout);
            this.iosLockTimeout = null;
        }
    },

    handleScroll: function () {
        var currentScrollTop = this.$window.scrollTop();
        var scrollDelta = currentScrollTop - this.lastScrollTop;

        if (Math.abs(scrollDelta) < this.scrollThreshold) {
            return;
        }

        // iOS bounce protection
        if (this.isIOSDevice) {
            var documentHeight = $(document).height();
            var windowHeight = this.$window.height();
            var maxScroll = documentHeight - windowHeight;
            
            if (currentScrollTop > maxScroll - 100) {
                return;
            }
        }

        if (currentScrollTop <= 0) {
            this.showFullHeader();
        } else if (scrollDelta > 0) {
            this.hideHeader();
        } else {
            if (this.isIOSDevice && this.iosScrollUpLock) {
                return;
            }
            
            this.showStickyHeader();
            
            if (this.isIOSDevice) {
                this.setIOSScrollUpLock();
            }
        }

        this.lastScrollTop = currentScrollTop;
    },

    setIOSScrollUpLock: function () {
        var self = this;
        
        if (this.iosLockTimeout) {
            clearTimeout(this.iosLockTimeout);
        }
        
        this.iosScrollUpLock = true;
        this.iosLockTimeout = setTimeout(function() {
            self.iosScrollUpLock = false;
            self.iosLockTimeout = null;
        }, 300);
    },

    showFullHeader: function () {
        this.$header.removeClass('header-hidden header-sticky');
        this.$body.removeClass('header-is-sticky');
        this.isSticky = false;
        this.iosScrollUpLock = false;
    },

    hideHeader: function () {
        if (!this.$header.hasClass('header-hidden')) {
            this.$header.addClass('header-hidden').removeClass('header-sticky');
            this.$body.removeClass('header-is-sticky');
            this.isSticky = false;
        }
        this.iosScrollUpLock = false;
    },

    showStickyHeader: function () {
        if (!this.isSticky) {
            this.$header.removeClass('header-hidden').addClass('header-sticky');
            this.$body.addClass('header-is-sticky');
            this.isSticky = true;
        }
    },

    destroy: function () {
        this.$window.off('scroll.stickyHeader resize.stickyHeader');
        $(document).off('wheel.stickyHeader');
        this.$header.removeClass('header-hidden header-sticky');
        this.$body.removeClass('header-is-sticky');
        if (this.scrollTimeout) {
            cancelAnimationFrame(this.scrollTimeout);
        }
        if (this.iosLockTimeout) {
            clearTimeout(this.iosLockTimeout);
        }
        this.isSticky = false;
        this.iosScrollUpLock = false;
    }
};

module.exports = function () {
    var $header = $('.site-header');
    if ($header.length) {
        stickyHeader.init();
    }
}; 